(function () {
// Warning!!! This an auto generated file. Any Changes will be lost. If u want to add or edit go to config.json 

a3_pilot_reports.constant("version", "appVersion_20250522234114");

})();